
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CacheService {

  constructor(private http: HttpClient) {
    
  }

    getInternalStoragedata(sskip: boolean, url: string, that: any): Observable<any>  {
        return new Observable<any>(observer => {
            let rresp: string|null = null;
            let attempt = 0;
            sskip = true;
            const ts = setInterval(()=>{
    
              rresp = localStorage.getItem(url);
              // console.log(rresp);
              console.log(attempt);
              attempt = attempt+1;
              if(rresp!=null && rresp != undefined && attempt<12){
                console.log(url+" frm inter localstorage");
                clearInterval(ts);
                observer.next(JSON.parse(rresp));
                observer.complete();
              }
              if(that.requests.length==0){
                clearInterval(ts);
              }
            }, 1000);
          });
    }

    getAfterRequest(ind: any, url: string, that: any, KeyValue: any, response: any) {
      if(ind>-1){
        that.requests.splice(ind,1);
        console.log('after requests [] .. '+JSON.stringify(that.requests))
      }
      if(that.requests.length==0){
        KeyValue.animStatus_update('end');
      }
      localStorage.setItem(url, JSON.stringify(response));
      localStorage.setItem(url+'_time', new Date().getTime()+'');
    }


    checkCache(url: string, requests: string[], getCRole: () => string, KeyValue: any): Observable<any> | null {
      const isPageRefreshed = localStorage.getItem('refreshed');
      const urlResp = localStorage.getItem(url);
      console.log(' .. navigator.onLine');
      console.log(url);
  
      let validTimeline = false;
      let localApiTime = localStorage.getItem(url + '_time');
      if (localApiTime != null) {
        const now1 = Date.now();
        const diff1 = now1 - parseInt(localApiTime);
        console.log(diff1 + '...time diff ...' + url);
        if (diff1 < 1000 && getCRole() === 'Student') {
          validTimeline = true;
        }
      }
  
      if (isPageRefreshed =='true' && (urlResp!=null && urlResp!=undefined && validTimeline == true)) {
        console.log('refreshed .. getting from cache');
        KeyValue.animStatus_update('end');
        const ind = requests.indexOf(url);
        if (ind > -1) {
          requests.splice(ind, 1);
          console.log('cache after requests [] .. ' + JSON.stringify(requests));
        }
        return new Observable<any>(observer => {
          observer.next(JSON.parse(urlResp!));
          observer.complete();
        });
      }
  
      return null;
    }
  }
      
   
    

